export const paymentDailyReport = {
    paymentDailyReport: "Payment Daily Report",
    from: "From",
    to: "To",
    exportReport: "Export Report",
    date: "DATE",
    "id": "ID",
    "operatorId": "OPERATOR ID",
    "moduleCode": "MODULE CODE",
    "auditTrail": "AUDIT TRAIL",
    "depositUserCount": "DEPOST USER",
    "depositCount": "DEPOSIT",
    "depositAmount": "DEPOSIT AMOUNT",
    "withdrawUserCount": "WITHDRAW USER",
    "withdrawCount": "WITHDRAW",
    "withdrawAmount": "WITHDRAW AMOUNT",
    "date": "DATE",
    "created_at": "CREATE AT",
    "updated_at": "UPDATE AT",
  };
  